import useSWR, { useSWRConfig } from 'swr'

import useAxios from './useAxios'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { Transfer } from '../types'

interface TransfersListResponse {
  transfers: Transfer[]
}

const useTransferList = (type: 'future' | 'past') => {
  const { user, token } = useSelector((state: RootState) => state.app)
  const instance = useAxios()
  const url = `ac/v1/transfers?type=${type}`
  const fetcher = () => instance.get(url).then((r) => r.data)

  const { mutate } = useSWRConfig()
  const { data, error, isValidating } = useSWR<TransfersListResponse>(
    () => (user && token ? [url, token] : false),
    fetcher
  )

  const refresh = () => mutate([url, token])

  return {
    response: data || { transfers: [] },
    isLoading: !error && !data,
    isValidating,
    isError: error,
    refresh,
  }
}

export default useTransferList
